module.exports = __webpack_public_path__ + "static/media/default-building.94865c78.svg";